export default (formData, resourceName, files) => {
  if (files instanceof FileList) {
    for (let x = 0; x < files.length; x++) {
      formData.append(`${resourceName}[completed_files][]`, files[x])
    }
  }
}
